import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeLegal extends ChangeBusinessDetails {
  type: string = 'ChangeLegal';
}
